import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { IPalopaySeo } from '@palomina/palomina-sanity';
import { useSiteMetadata } from '@palomina/palomina-website/hooks';
import FacebookSEO from './Facebook';
import TwitterSEO from './Twitter';

interface IProps {
  pageTitle: string;
  description?: string;
  openGraphImageUrl?: string;
  keywords?: string[];
  pathname?: string;
}

const SEO = ({
  pageTitle,
  pathname = '/',
  description: pageDescription,
  openGraphImageUrl
}: IProps) => {
  const globalSEO: IPalopaySeo = useStaticQuery(graphql`
    query {
      sanityPalopaySettings {
        seo {
          title
          keywords
          # tagline
          description
          image {
            asset {
              url
            }
          }
          # favicon {
          #   asset {
          #     url
          #   }
          # }
        }
      }
    }
  `)?.sanityPalopaySettings?.seo;

  const meta = useSiteMetadata();

  if (!globalSEO) {
    return null;
  }

  const {
    description: globalDescription,
    favicon,
    image,
    keywords,
    // tagline,
    title: globalTitle
  } = globalSEO;

  const titleText =
    pageTitle === `Home` ? `${globalTitle}` : `${pageTitle} | ${globalTitle}`;
  const descriptionText = pageDescription || globalDescription;
  const ogImageUrl = openGraphImageUrl || image.asset.url!;
  const faviconUrl = favicon?.asset?.url!;
  const keywordsText = keywords ? keywords.join(', ') : null;

  const canonicalPath = pathname.startsWith('/') ? pathname : `/${pathname}`;

  return (
    <>
      <title>{titleText}</title>
      <link rel="icon" type="image/png" href={faviconUrl} />
      <link rel="canonical" href={`${meta.siteUrl}${canonicalPath}`} />
      <meta name="description" content={descriptionText} />

      {keywordsText && <meta name="keywords" content={keywordsText} />}

      <FacebookSEO
        description={descriptionText}
        ogImageUrl={ogImageUrl}
        siteUrl={meta.siteUrl}
        title={titleText}
      />
      <TwitterSEO
        description={descriptionText}
        ogImageUrl={ogImageUrl}
        title={titleText}
      />
    </>
  );
};

export default SEO;
